import { useEffect } from "react";
import Link from "next/link";

import { useFetchProjectListing } from "modules/projects/api";

import Button from "ui-components/Button";

import * as flowConfig from "flows/network-failure-analysis/config";
import AnalysisSummary from "flows/network-failure-analysis/elements/Context-Summary";

import * as appConfig from "data-apps/network-field-service/config";

const Listing = () => {
  const [data, _, hasNextPage, getNextPage] = useFetchProjectListing(
    flowConfig.FLOW_NAME
  );

  useEffect(() => {
    hasNextPage && getNextPage();
  }, [getNextPage, hasNextPage, data]);

  const listing = data.flat();
  const projects = listing.filter(
    (p) =>
      Object.keys(p.meta_data[flowConfig.DEFAULT_MODELS_KEY] || {}).length >= 1
  );
  return (
    <div>
      <p className="text-right">
        <Link href={`/${flowConfig.FLOW_NAME}/create`}>
          <Button className="text-right">Create New Project</Button>
        </Link>
      </p>
      {projects.length >= 1 && (
        <table className="table table-auto w-full">
          <thead>
            <tr>
              <th className="font-semibold text-left table-cell w-1/6">
                <p className="px-1 mx-1">Creation Details</p>
              </th>
              <th className="font-semibold text-left table-cell w-1/2">
                <p className="px-1 mx-1">Project</p>
              </th>
              <th className="font-semibold text-left table-cell">
                <p className="px-1 mx-1">Context</p>
              </th>
            </tr>
          </thead>
          <tbody>
            {projects.map((d) => (
              <tr key={d.id} className="table-row border-t-2">
                <td className="table-cell">
                  <div className="m-1">
                    <p>
                      {new Date(d.created_time).toLocaleDateString(undefined, {
                        hour: "numeric",
                        minute: "numeric",
                        hour12: true,
                      })}
                    </p>
                    <p>Created By: {d.owner}</p>
                  </div>
                </td>
                <td className="table-cell">
                  <p className="m-1">
                    <Link href={`/data-apps/${appConfig.APP_LINK}/${d.id}`}>
                      <a className="text-primary-main">
                        {d.name ? (
                          <span>
                            <span className="font-bold">{d.name}</span> ({d.id})
                          </span>
                        ) : (
                          <span className="font-bold">{d.id}</span>
                        )}
                      </a>
                    </Link>
                  </p>
                </td>
                <td className="table-cell">
                  <div className="m-1">
                    <AnalysisSummary project={d} />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Listing;
